import report from '@/utils/reportData';
import {
  isServerRender, isNative, platWindow,
} from '@/utils/env';
import logger from '@/utils/logger';
import { getApp } from '@/utils/util';

export const timePoint = { // native打点列表
  appStart: 0,
  created: 0,
  mounted: 0,
  dataLoaded: 0,
  pageActive: 0,
};
let requestType;

/**
 * 记录时间点
 * @param pointName 时间名称
 * @param isReset 是否重置时间点
 */
function markPoint(pointName, isReset) {
  if (isNative) {
    if (Object.prototype.hasOwnProperty.call(timePoint, pointName)) {
      if (!timePoint[pointName] || isReset) {
        timePoint[pointName] = Date.now();
        if (pointName === 'pageActive') {
          reportPoint();
        }
      }
    } else {
      logger.warn(`${pointName}不在打点列表里，请使用以下点: ${JSON.stringify(timePoint)}`);
    }
  } else if (!isServerRender && typeof window !== 'undefined' && window.timePoint) { // web端同时也上报自定义打点
    window.timePoint.mark(pointName, isReset);
  }
}

function getTime(begin, end) {
  if (begin && end && end - begin >= 0) {
    return end - begin;
  }
  return 0;
}

function reportPoint() {
  const cache = reportPoint;
  if (cache.isReport) {
    return;
  }

  const commonParams = {
    operid: '1623000010102',
  };

  if (isNative) {
    const traceInfo = getApp()?.$options?.$superProps?.traceInfo || {};
    let moduleName = '';

    try {
      const params = JSON.parse(getApp().$options.$superProps.params);
      moduleName = params.moduleName;
    } catch (e) {
      console.error(e);
    }

    const {
      startPreProcess = 0,
      endPreProcess = 0,
      startSearchBundle = 0,
      endSearchBundle = 0,
      startDownloadBundle = 0,
      endDownloadBundle = 0,
      startCreateEngine = 0,
      endCreateEngine = 0,
      startLoadBundle = 0,
      endLoadBundle = 0,
      renderType = 'native',
    } = traceInfo;
    const startTime = startPreProcess || startSearchBundle || startDownloadBundle || startCreateEngine; // 部分时间可能为0
    const clientEndTime = endLoadBundle
      || endCreateEngine
      || endDownloadBundle
      || endSearchBundle
      || endPreProcess; // 部分时间可能为0
    const timeArr = [];
    timeArr[0] = getTime(startPreProcess, endPreProcess); // PreProcess
    timeArr[1] = getTime(startSearchBundle, endSearchBundle); // SearchBundle
    timeArr[2] = getTime(startDownloadBundle, endDownloadBundle);// DownloadBundle
    timeArr[8] = getTime(startCreateEngine, endCreateEngine);// CreateEngine
    timeArr[3] = getTime(startLoadBundle, endLoadBundle); // LoadBundle
    timeArr[4] = getTime(clientEndTime, timePoint.created); // created
    timeArr[5] = getTime(timePoint.created, timePoint.mounted); // mounted
    timeArr[6] = getTime(timePoint.mounted, timePoint.dataLoaded); // dataLoaded
    timeArr[7] = getTime(timePoint.dataLoaded, timePoint.pageActive); // pageActive

    const params = {
      ...commonParams,
      contentname: moduleName,
      contenttype: requestType, // 请求类型： 'preCreated','preRequest','preCache','preRequestTimeOut',
      contentid: renderType, // 渲染类型 native、flutter
      staytime: timePoint.pageActive - startTime, // 总耗时
      resourceid: getTime(startTime, clientEndTime), // 客户端耗时
      resourcename: getTime(clientEndTime, timePoint.pageActive), // 页面耗时
      resourcetype: getTime(clientEndTime, timePoint.appStart), // appStart的耗时
    };
    timeArr.forEach((item, index) => {
      params[`ext${index + 1}`] = item;
    });
    logger.info('speedReport traceInfo', traceInfo);
    logger.info('speedReport', params);
    report(params);
  } else if (platWindow && platWindow.timePoint) {
    // 暂时去掉， web打点需要再梳理
    // const timePoint = platWindow.timePoint;
    // const params = {
    //   ...commonParams,
    //   pageid: 1624,
    //   contenttype: platWindow.navigator.userAgent,
    //   indexid: isAsyncRender ? 2 : 3,
    //   ext1: getTime(timePoint.head, timePoint.cssReady),
    //   ext2: getTime(timePoint.head, timePoint.created),
    //   ext3: getTime(timePoint.head, timePoint.mounted),
    //   ext4: getTime(timePoint.head, timePoint.ssrOutletReady),
    //   ext5: getTime(timePoint.head, timePoint.cgiBegin),
    //   ext6: getTime(timePoint.head, timePoint.cgiEnd),
    //   ext7: getTime(timePoint.head, timePoint.pageActive),
    //   ext8: getTime(timePoint.head, timePoint.jsEnd),
    //   ext9: getTime(timePoint.head, timePoint.jsBegin),
    // };
    // logger.info('speedReport', params);
    // report(params);
  }

  cache.isReport = true;
}
function setRequestType(type) {
  requestType = type;
}

export default {
  markPoint,
  report: reportPoint,
  setRequestType,
};
